import React, { Component } from "react";
import { observer } from "mobx-react";
import Tab from "../tap";
import Title from "../GoBackShop";
import Load from "../loaded";
import VestWindow from "../VestWindow";
import SampleQuestion from "../SampleQuestion";
import flowar from "../../static/images/falower.png";
import left from "../../../src/static/images/left.png";
import home from "../../store/index";
import "./index.css";
import { queryAlias } from "../../static/js/http";
@observer
class WriteLitter extends Component {
  constructor() {
    super();
    this.state = {
      maxLen: 500,
      num: "",
      vestShow: false,
      circle: false,
      alias: "",
      show: true,
      sampleShow: false,
    };
  }
  Iask(e) {
    if (e.target.value.length > 500) {
      home.num = e.target.value.substring(0, 500);
    } else {
      home.num = e.target.value;
    }
  }
  Myask() {
    if (home.num === "") {
      home.askerror = true;
      setTimeout(() => {
        home.askerror = false;
      }, 1000);
    } else {
      home.askLoad = true;
      home.askLoadShow = true;
      let textdom = document.querySelector(".textarea");
      textdom.blur();
      setTimeout(() => {
        home.Myaskq(home.num, home.circle, this.state.alias);
      }, 1000);
    }
  }
  // 马甲弹窗的显示和隐藏
  vestShow = (val) => {
    if (home.circle) {
      home.circle = false;
    } else {
      this.setState({ vestShow: val });
    }
  };
  //示例问题显示隐藏
  sampleShow = val =>{
    this.setState({ sampleShow: val})
  }

  vestTip = (data) => {
    if (data.type) {
      if (data.value !== "") {
        this.vestShow(false);
        home.circle = true;
        this.setState({ alias: data.value });
      }
    } else {
      this.vestShow(false);
      home.circle = false;
      if (data.value !== "") {
        this.setState({ alias: data.value });
      }
    }
  };

  componentDidMount() {
    const WIN_HEIGHT = window.innerHeight;
    window.addEventListener("resize", () => {
      if (window.innerHeight < WIN_HEIGHT) {
        // 说明视口被改变，执行隐藏元素操作
        this.setState({
          show: false,
        });
      } else {
        // 执行显示元素操作
        if (document.querySelector(".textarea").scrollTop > 0) {
          document.querySelector(".textarea").scrollTop = 0;
        }
        this.setState({
          show: true,
        });
      }
    });
    home.circle = false;
    queryAlias().then((res) => {
      if (res !== null) {
        this.setState({
          alias: res,
        });
      } else {
        this.setState({
          alias: "",
        });
      }
    });
  }
  render() {
    return (
      <div className="Person">
        <Title />
        <div className="W_cnt">
          <p className="titleTip">
            所有提问均会匿名，可如实地提出你想问的问题~
          </p>
          <div
            className="Vest"
            onClick={() => {
              this.vestShow(true);
            }}
          >
            <span>使用马甲</span>
            <div>
              {this.state.alias !== "" ? (
                <p>{this.state.alias}</p>
              ) : (
                <span>请输入</span>
              )}
              <img src={left} alt="" />
            </div>
          </div>
          <div className="Vest" onClick={() => { this.sampleShow(true); }}          >
            <span>示例问题</span>
            <div>
              <img src={left} alt="" />
            </div>
          </div>
          <div className="w_center">
            <div className="w_c_wrap">
              <div className="w_c_c">
                <textarea
                  className="textarea"
                  name=""
                  id=""
                  rows="12"
                  onChange={(e) => {
                    this.Iask(e);
                  }}
                  value={home.num}
                ></textarea>
              </div>
            </div>

            <div className="w_bottom3">
              {this.state.alias !== "" ? (
                <span>——From {this.state.alias}</span>
              ) : (
                ""
              )}
            </div>
            <div className="w_bottom">
              <span>{home.num.length}/500</span>
              <img src={flowar} alt="" />
              <p
                onClick={() => {
                  this.Myask();
                }}
              >
                投递
              </p>
              <div></div>
            </div>
          </div>
          <p className="foot">你的提问将会匿名投递，请说出你的真实困惑。</p>
        </div>
        {this.state.show ? <Tab /> : ""}

        {/*  发送中 和发送成功 */}
        {home.askLoad ? <Load /> : ""}
        {/* 发送失败 */}
        {home.askerror ? (
          <div className="w_error">
            <p>{home.num === "" ? "请填写问题" : "网络错误"}</p>
          </div>
        ) : (
          ""
        )}
        {/*  马甲弹窗*/}
        {this.state.vestShow ? (
          <VestWindow placeholder="请输入马甲" submit={this.vestTip} />
        ) : (
          ""
        )}
        {/*  示例问题 */}
        {this.state.sampleShow ? (
          <SampleQuestion  close={this.sampleShow} />
        ) : (
          ""
        )}
      </div>
    );
  }
}
export default WriteLitter;
